<template>
  <v-app-bar
    app
    dark
    color="primary"
  >
    <v-app-bar-nav-icon @click="handleDrawerToggle" />
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn
        text
        class="hidden-xs-only"
        @click="handleFeedback()"
      >
        <v-icon class="mr-2">
          mdi-message-text-outline
        </v-icon>
        <span>Feedback</span>
      </v-btn>

      <v-btn
        icon
        class="hidden-sm-and-up"
        @click="handleFeedback()"
      >
        <v-icon>
          mdi-message-text-outline
        </v-icon>
      </v-btn>

      <v-menu
        offset-y
        origin="center center"
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon slot="activator" v-on="on">
            <v-icon>mdi-help</v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in helpMenus"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon" class="mr-4">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- <v-menu
        offset-y
        origin="center center"
        class="elevation-1"
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon text slot="activator" v-on="on">
            <v-badge color="warning" dot left overlap>
              <v-icon medium>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <notification-list></notification-list>
      </v-menu> -->

      <!-- <v-menu
        offset-y
        origin="center center"
        class="elevation-1"
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn text small slot="activator" v-on="on" class="pr-1">
            <img :src="'/static/img/' + localeText.toLowerCase() + '.svg'" alt="English" width="30px" class="pr-1" />
            <v-icon small>
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="$vuetify.lang.current">
            <v-list-item
              @click="handleChangeLocale(item)"
              v-for="item in availableLanguages"
              :key="item.value"
              :value="item.value"
            >
              <v-list-item-title v-text="item.text" />
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu> -->
      
      <v-menu offset-y origin="center center" transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn text slot="activator" v-on="on" class="pr-1">
            <v-avatar size="35" color="white" class="">
              <span class="primary--text headline">{{ currentUser.username.charAt(0) }}</span>
            </v-avatar>
            <v-icon small>
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in profileMenus"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon" class="mr-4">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>

    <v-dialog
      v-model="dialogLogout"
      max-width="400px"
    >
      <v-card>
        <v-card-title class="headline">Are you sure you want to logout?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLogout = false">Cancel</v-btn>
          <v-btn color="primary" dark @click="handleLogout()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSupport"
      max-width="400px"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            Request Support
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="dialogSupport = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container class="subtitle-1">
            <div class="mb-2">For support please contact X-zam Labs&reg;:<br /></div>
            <v-list dense>
              <v-list-item-group>
                <v-list-item @click="handleSupportCall()">
                  <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    (305) 914-1500
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="handleSupportEmail()">
                  <v-list-item-icon>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    info@labonlocale.com
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="dialogSupport = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogFeedback"
      max-width="600px"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            {{ !feedback.feedbackType ? 'Share Feedback' : feedback.feedbackType == 'bug' ? 'Report a Bug' : 'Suggest a Feature' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              v-if="feedback.feedbackType"
              @click="feedback.feedbackType = null"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <v-btn
              icon
              @click="dialogFeedbackClose()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container class="pt-6">
            <v-fade-transition hide-on-leave>
              <v-row v-if="!feedback.feedbackType">
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-btn
                    dark
                    block
                    color="info"
                    class="pa-4"
                    style="width: 100%; height: 100%;"
                    @click="feedback.feedbackType = 'feature'"
                  >
                    <v-col cols="12">
                      <v-row
                        width="100%"
                        style="place-content: center; margin-bottom: 12px;"
                      >
                        <v-icon large>
                          mdi-lightbulb-on-outline
                        </v-icon>
                      </v-row>
                      <v-row width="100%" style="place-content: center">
                        <span class="subtitle-1 font-weight-medium">
                          Suggest a Feature
                        </span>
                      </v-row>
                    </v-col>
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-btn
                    dark
                    block
                    color="error"
                    style="width: 100%; height: 100%;"
                    @click="feedback.feedbackType = 'bug'"
                  >
                    <v-col cols="12">
                      <v-row
                        width="100%"
                        style="place-content: center; margin-bottom: 12px;"
                      >
                        <v-icon large>
                          mdi-bug-outline
                        </v-icon>
                      </v-row>
                      <v-row width="100%" style="place-content: center">
                        <span class="subtitle-1 font-weight-medium">
                          Report a Bug
                        </span>
                      </v-row>
                    </v-col>
                  </v-btn>
                </v-col>
              </v-row>
            </v-fade-transition>

            <v-fade-transition hide-on-leave>
              <div v-if="feedback.feedbackType">
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="feedback.feedbackSummary"
                      label="Summarize your feedback"
                      :rules="rules.required"
                      hint="Required"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="feedback.feedbackDetail"
                      label="Explain in more detail (optional)"
                      rows="2"
                      :hint="'Give us as much information as you can.'"
                      persistent-hint
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </div>
            </v-fade-transition>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="feedback.feedbackType">
          <v-spacer></v-spacer>
          <v-btn @click="dialogFeedbackClose()">Cancel</v-btn>
          <v-btn color="primary" dark @click="sendFeedback()">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
// import NotificationList from '@/components/NotificationList'
import FeedbackService from "../services/feedback.service"

export default {
  name: 'AppToolbar',
  components: {
    // NotificationList
  },
  data() {
    return {
      profileMenus: [
        // {
        //   icon: 'mdi-badge-account-horizontal-outline',
        //   href: '#',
        //   title: 'Profile',
        //   click: this.handleProfile
        // },
        // {
        //   icon: 'mdi-cog-outline',
        //   href: '#',
        //   title: 'Settings',
        //   click: this.handleSettings
        // },
        {
          icon: 'mdi-power',
          href: '#',
          title: 'Logout',
          click: this.handleDialogLogout
        }
      ],
      helpMenus: [
        {
          icon: 'mdi-face-agent',
          href: '#',
          title: 'Support',
          click: this.handleSupport
        },
        {
          icon: 'mdi-book-open-outline',
          href: '/static/doc/lol-portable-user-manual.pdf',
          title: 'Manual',
          click: this.handleManual,
          target: '_blank'
        },
        // {
        //   icon: 'mdi-lightbulb-on-outline',
        //   href: '#',
        //   title: 'Feedback',
        //   click: this.handleFeedback
        // }
      ],
      dialogLogout: false,
      dialogSupport: false,
      dialogFeedback: false,
      feedback: {
        feedbackType: null,
        feedbackSummary: '',
        feedbackDetail: ''
      },
      rules: {
        required: [
          value => value.length != 0 || 'Required'
        ]
      },
    }
  },
  
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    currentLol() {
      return this.$store.state.lol;
    },

    availableLanguages() {
      const { locales } = this.$vuetify.lang
      return Object.keys(locales).map((lang) => {
        return {
          text: locales[lang].label,
          value: lang
        }
      })
    },

    localeText() {
      const find = this.availableLanguages.find(
        (item) => item.value === this.$vuetify.lang.current
      )
      return find.text
    },

    breadcrumbs() {
      const { matched } = this.$route
      return matched.map((route, index) => {
        const to =
          index === matched.length - 1
            ? this.$route.path
            : route.path || route.redirect
        const text = this.$vuetify.lang.t('$vuetify.menu.' + route.meta.title)
        return {
          text: text,
          to: to,
          exact: true,
          disabled: false
        }
      })
    }
  },

  methods: {
    handleDrawerToggle() {
      this.$emit('side-icon-click')
    },

    handleDialogLogout() {
      this.dialogLogout = true
    },

    handleLogout() {
      // if (window.confirm('Are you sure you want to logout?')) {
        this.$store.dispatch('auth/logout')
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: 'Logout successful',
          color: 'info'
        })
        setTimeout(() => this.$router.push('/auth/login'), 1000);
      // }
    },

    // handleChangeLocale({ value }) {
    //   this.$vuetify.lang.current = value
    // },

    // handleGoBack() {
    //   this.$router.go(-1)
    // },

    // handleSettings() {},

    handleProfile() {},

    handleSupport() {
      this.dialogSupport = true
    },
    
    handleSupportCall() {
      window.open("tel:+1800229933")
    },

    handleSupportEmail() {
      window.open("mailto:info@labonlocale.com")
    },

    handleManual() {
      // window.open("http://www.labonlocale.com/portable-manual/")
    },

    handleFeedback() {
      this.dialogFeedback = true
    },

    dialogFeedbackClose() {
      this.feedback.feedbackType = null
      this.dialogFeedback = false
    },

    sendFeedback() {
      this.feedback.userID = this.currentUser.userID,
      this.feedback.customerID = this.currentUser.customerID,
      this.feedback.lolID = this.currentLol.lolID

      console.log(this.feedback)

      FeedbackService.create(this.feedback)
        .then(response => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'Thank you! Your feedback was stored successfully',
            color: 'success'
          })
        })
        .catch(e => {
          console.log(e);
        });

      this.dialogFeedback = false
    },
  },

  created() {}
}
</script>

<style lang="sass" scoped></style>
